import { getApiUrl } from '../../../config/api';
import { post } from '../../../utils/request-manager';

export default class EditModuloViewController {
  constructor() {
    this.modulo = {
      IdModulo: 0,
      Nombre: '',
      Ruta: '',
      RutaApi: '',
      Permisos: '',
      EsActivo: true
    };
    this.loading = false;
    this.saving = false;
    this.error = null;
    this.idModulo = null;
  }

  // Inicializar el controlador con el ID del módulo
  async initialize(idModulo) {
    this.idModulo = idModulo;
    await this.loadModulo();
  }

  // Cargar módulo desde la API
  async loadModulo() {
    if (!this.idModulo) {
      this.error = 'ID de módulo no válido';
      return;
    }

    this.loading = true;
    this.error = null;

    try {
      const response = await post(getApiUrl('/api/Modulo/lectura'), {
        IdModulo: Number(this.idModulo)
      });
      
      if (response.data.Data && response.data.Data.length > 0) {
        this.modulo = response.data.Data[0];
        this.loading = false;
      } else {
        this.error = 'Módulo no encontrado.';
        this.loading = false;
      }
    } catch (error) {
      console.error('Error al cargar módulo:', error);
      this.error = 'No se pudo cargar el módulo. Por favor, intente nuevamente.';
      this.loading = false;
    }
  }

  // Actualizar campo del formulario
  updateField(field, value) {
    if (field in this.modulo) {
      this.modulo[field] = value;
    }
  }

  // Validar formulario
  validateForm() {
    const errors = [];
    
    if (!this.modulo.Nombre || this.modulo.Nombre.trim() === '') {
      errors.push('El nombre es requerido');
    }
    
    return {
      isValid: errors.length === 0,
      errors
    };
  }

  // Guardar cambios del módulo
  async saveModulo() {
    if (this.saving) return { success: false, message: 'Ya se está guardando' };
    
    const validation = this.validateForm();
    if (!validation.isValid) {
      return {
        success: false,
        message: validation.errors.join(', ')
      };
    }

    this.saving = true;

    try {
      const formData = {
        Modulo: this.modulo
      };
      
      const response = await post(getApiUrl('/api/Modulo/guardar'), formData, {}, false);
      
      this.saving = false;
      
      if (response.data.Number > 0) {
        return {
          success: true,
          message: 'Módulo actualizado correctamente',
          data: response.data
        };
      } else {
        return {
          success: false,
          message: 'Error al actualizar el módulo'
        };
      }
    } catch (error) {
      console.error('Error al actualizar módulo:', error);
      this.saving = false;
      return {
        success: false,
        message: 'No se pudo actualizar el módulo. Por favor, verifique los datos e intente nuevamente.'
      };
    }
  }
}